module.exports = __webpack_public_path__ + "img/calendar-sample-1.da88f1a3.png";